import { Crm9AccountDetails } from "@/components/crm-demos/crm-9-account-details"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_crm-demos/account-details")({
  component: AccountDetailsPage,
  head: () => ({ meta: [{ title: "Account Details" }] }),
});

function AccountDetailsPage() {
  return <Crm9AccountDetails />
}
